var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left"}},[_c('Table',{staticStyle:{"width":"100%"},attrs:{"columns":_vm.ContributionLabel,"data":_vm.ContributionData,"show-header":true},scopedSlots:_vm._u([{key:"name",fn:function(ref){
var row = ref.row;
return [_c('a',[_vm._v(_vm._s(row.name))])]}},{key:"percentage",fn:function(ref){
var row = ref.row;
return [_c('Progress',{attrs:{"percent":row.percentage,"stroke-color":['#0dc9fc', '#ff8102']}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }